import { store as commonReactionsStore } from '@atlassian/jira-common-atlaskit-services/src/reactions.tsx';

export const reactionStore = commonReactionsStore();
